import React from 'react';
import { useReveal } from '../lib/useReveal';
const TESTIMONIALS = [{
  text: 'Nunca pensé que podía aprender Reiki a este nivel desde casa. Los protocolos del Tomo VI me salvaron en más de una situación con pacientes.',
  author: 'Valentina R.',
  role: 'Buenos Aires'
}, {
  text: 'El Manual Anti-Dudas solo ya valió todo lo que pagué. Finalmente tengo respuestas claras a todo lo que me frenaba.',
  author: 'Claudia M.',
  role: 'Terapeuta holística'
}, {
  text: 'El Tomo V me dio la estructura que me faltaba. Hoy tengo clientas fijas y lista de espera.',
  author: 'Fernanda L.',
  role: 'Maestra Reiki'
}, {
  text: 'El Diario de Progreso cambió todo. Ver los números mejorar semana a semana me dio la evidencia que necesitaba para seguir.',
  author: 'Mariana G.',
  role: 'Practicante nivel 2'
}, {
  text: 'Elegí el Kit Pro y fue la mejor decisión. Las plantillas y el guión de primera sesión me ahorraron meses de prueba y error.',
  author: 'Rocío P.',
  role: 'Terapeuta integrativa'
}, {
  text: 'Empecé sin saber nada de Reiki y en menos de un mes ya estaba haciendo sesiones a familiares. La estructura paso a paso es increíble.',
  author: 'Laura S.',
  role: 'Córdoba'
}];
export function TestimonialsSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section id="testimonials" className="bg-[#0a0a0a] py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-436">
      <div className="container mx-auto max-w-5xl" data-id="element-437">
        <div ref={ref1} className={`reveal text-center mb-8 ${vis1 ? 'is-visible' : ''}`} data-id="element-438">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-439">
            Lo que dicen quienes ya lo tienen
          </h2>
          <div className="flex justify-center gap-1 mb-4" data-id="element-440">
            {[1, 2, 3, 4, 5].map(star => <span key={star} className="text-[#eab308] text-xl" data-id="element-441">
                ★
              </span>)}
          </div>
        </div>

        <div ref={ref2} className={`reveal grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 ${vis2 ? 'is-visible' : ''}`} data-id="element-442">
          {TESTIMONIALS.map((t, i) => <div key={i} className="bg-[#111111] p-4 sm:p-5 rounded-xl border border-white/10 shadow-lg flex flex-col" data-id="element-443">
              <div className="flex gap-1 mb-4" data-id="element-444">
                {[1, 2, 3, 4, 5].map(star => <span key={star} className="text-[#eab308] text-sm" data-id="element-445">
                    ★
                  </span>)}
              </div>
              <p className="text-gray-300 italic mb-4 flex-grow text-xs sm:text-sm leading-relaxed" data-id="element-446">
                "{t.text}"
              </p>
              <div data-id="element-447">
                <p className="text-white font-bold font-serif" data-id="element-448">{t.author}</p>
                <p className="text-[#eab308] text-xs uppercase tracking-wider mt-1" data-id="element-449">
                  {t.role}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}